import { createAction, props } from '@ngrx/store';
import { PaginationState } from '@shared/models/pagination-state';
import { Sorting } from '@shared/models/sorting';
import { LeadFilters } from '@shared/models/lead-filters';
import { Lead } from '@shared/models/lead';

export const loadLeads = createAction(
  '[Leads] Load Leads',
  props<{ filters: LeadFilters; paginationState: PaginationState; sorting: Sorting }>(),
);

export const loadLeadsSuccess = createAction(
  '[Leads] Load Leads Success',
  props<{ leads: Lead[]; paginationState: PaginationState }>(),
);

export const loadLeadsFailure = createAction('[Leads] Load Leads Failure', props<{ error: any }>());
